export const MAX_INVOICES_PER_INVOICE_LIST = 500;

export const getInvoiceIdentity = (invoice: any): any => {
  const invoiceId =
    invoice?.originalInvoiceId ?? invoice?.invoiceId ?? invoice?.id;

  if (invoiceId !== undefined && invoiceId !== null && invoiceId !== "") {
    return `id:${invoiceId}`;
  }

  if (invoice?.invoiceSerial || invoice?.invoiceNumber) {
    return `invoice:${invoice.invoiceSerial || ""}:${
      invoice.invoiceNumber || ""
    }`;
  }

  return invoice;
};

export const countUniqueInvoices = (...invoiceGroups: any[][]): number => {
  const invoiceIdentities = new Set<any>();

  invoiceGroups.forEach((invoices) => {
    (invoices || []).filter(Boolean).forEach((invoice) => {
      invoiceIdentities.add(getInvoiceIdentity(invoice));
    });
  });

  return invoiceIdentities.size;
};

export const exceedsInvoiceListSelectionLimit = (
  existingInvoices: any[] = [],
  selectedInvoices: any[] = [],
): boolean =>
  countUniqueInvoices(existingInvoices, selectedInvoices) >
  MAX_INVOICES_PER_INVOICE_LIST;
